module.exports = __webpack_public_path__ + "static/media/MapRegion.c94936cc.svg";